



















































import { Component, Vue } from 'vue-property-decorator';
import { ICourse, IProgram, SearchType } from '../Scripts/ISearchService';
import { BvEvent } from 'bootstrap-vue';

import { PrintType, PrintContext } from '../Scripts/PrintContext';
import { QueryString } from '../Scripts/QueryString';

import FavoritesSlider from './FavoritesSlider.vue';
import FavoritesManage from './FavoritesManage.vue';
import EmailFavorites from './EmailFavorites.vue';

import ActionTracker, {
	OpenFavoritesEvent, CloseFavoritesEvent,
	OpenCompareEvent, CloseCompareEvent,
	OpenEmailProgramsEvent, CloseEmailProgramsEvent, SendEmailProgramsEvent,
	OpenPrintFavoritesEvent
} from '../Scripts/AnalyticsEvents';

enum FavMode { Manage, Compare, EmailFavorites }

@Component({
	components: {
		FavoritesSlider, FavoritesManage, EmailFavorites
	}
})
export default class FavoritesCount extends Vue {
	private version = 1;

	private selected: IProgram[] | ICourse[] = [];
	private mode: FavMode = FavMode.Manage;

	private busy = false;
	private emailDone = false;

	public async send (): Promise<void> {
		ActionTracker.track(new SendEmailProgramsEvent(this.selectedCount));

		// TODO:TRS Do not know how to do this without any
		// eslint-disable-next-line
		await (this.$refs.emailFavorites as any).send();
	}

	public get indeterminate (): boolean {
		return !(this.selected.length === 0 || this.selected.length === this.count);
	}

	public get allSelected (): boolean {
		return this.selected.length === this.count;
	}

	public get searchType (): SearchType {
		return this.$store.state.searchType;
	}

	public print (): void {
		const ids = (this.selected as (IProgram & ICourse)[]).map((p) => p.id).join(',');

		const searchTypeName = SearchType[this.searchType].toLowerCase() + 's';

		const path = `${this.$route.path}?ids=${ids}&search=${searchTypeName}`;

		const query = new QueryString(this.$router);

		query.set('print', 'true').navigate();

		const print = new PrintContext(PrintType.Favorites, this.selected, this.searchType, path);
		this.$store.commit('setPrintContext', print);

		ActionTracker.track(new OpenPrintFavoritesEvent());
	}

	public defavorite (): void {
		// Enumerating this.selected directly while removing items was unreliable, leading to
		// missing items is some situtions. Working against a copy seems consitently reliable.
		// Future - consider adding a 'removeFavorites' plural to reduce commits
		const itemsToRemove = [...this.selected];
		itemsToRemove.forEach((p: IProgram | ICourse) => this.$store.commit('removeFavorite', p));

		this.selected = [];
	}

	public updateStatus (status: boolean): void {
		this.busy = status;
	}

	get favorites (): IProgram[] | ICourse[] {
		switch (this.$store.state.searchType) {
			case SearchType.Course: return this.$store.state.courseFavorites;
			case SearchType.Program: return this.$store.state.favorites;
			default: return [];
		}
	}

	get count (): number {
		return this.favorites.length;
	}

	get hasFavs (): boolean {
		return this.count > 0;
	}

	get favCountDisplay (): string {
		return `${this.count} Favorite${this.count === 1 ? '' : 's'}`;
	}

	get selectedCount (): number {
		return this.selected.length;
	}

	get selectedCountDisplay (): string {
		return `${this.selectedCount} Favorite${this.selectedCount === 1 ? '' : 's'} Selected`;
	}

	get moreDisabled (): boolean {
		return this.selectedCount < 1;
	}

	get compareDisabled (): boolean {
		return this.selectedCount < 2;
	}

	get size (): string {
		return this.isManage || this.isEmailing ? 'lg' : 'xl';
	}

	get title (): string {
		if (!this.hasFavs) {
			return 'No Favorites to Show!';
		}

		return this.isManage
			? `${this.favCountDisplay},  ${this.selectedCount} Selected`
			: this.isCompare
				? `Comparison - ${this.selectedCount} Selected`
				: `Email Favorites - ${this.selectedCount} Selected `;
	}

	public compare (): void {
		ActionTracker.track(new OpenCompareEvent(this.selectedCount));
		this.mode = FavMode.Compare;
	}

	get isCompare (): boolean {
		return this.mode === FavMode.Compare;
	}

	public manage (): void {
		this.mode = FavMode.Manage;
	}

	get isManage (): boolean {
		return this.mode === FavMode.Manage;
	}

	public email (): void {
		this.emailDone = false;
		this.mode = FavMode.EmailFavorites;
		ActionTracker.track(new OpenEmailProgramsEvent());
	}

	get isEmailing (): boolean {
		return this.mode === FavMode.EmailFavorites;
	}

	public show (): void {
		ActionTracker.track(new OpenFavoritesEvent(this.count));
	}

	public onClose (event: BvEvent): void {
		switch (this.mode) {
			case FavMode.Compare:
				// return the user to the manage area to pick other favorites
				this.manage();
				event.preventDefault();
				ActionTracker.track(new CloseCompareEvent());
				break;
			case FavMode.EmailFavorites:
				// return the user to the manage area to pick other favorites
				this.manage();
				event.preventDefault();
				ActionTracker.track(new CloseEmailProgramsEvent());
				break;
			case FavMode.Manage:
				// reset and close
				this.selected = [];
				ActionTracker.track(new CloseFavoritesEvent(this.$router));
				this.$emit('close');
				break;
			default:
				alert(`Unrecognized favorites mode:${this.mode}`);
		}
	}

	public toggleAll (checked: boolean): void {
		this.selected = checked ? this.favorites : [];
	}

	public notImplemented (): void {
		alert('I\'m glad that you tried but this feature is not implemented, yet. ');
	}
}
